import React from 'react'
import { contentAreaDataMapper } from 'Helpers/transform'
import SelectaTopicCardBlock from './SelectaTopicCardBlock'

const SelectaTopicBlock = ({ data, inEditMode }) => {
  const { Heading, MainContentArea } = data
  const blockData = contentAreaDataMapper(MainContentArea)

  return (
    <div className="container mx-auto max-w-screen-xl">
      <div className="xl:mx-20 md:mx-16 sm:mx-12 mx-4 xl:py-18 lg:py-10 md:py-8 py-6">
        <h2 data-epi-edit="Heading" className="lg:text-4xl md:text-2xl text-xl font-bold font-display lg:mb-20 sm:mb-12 mb-8">
          {Heading} {inEditMode && !Heading && 'Click to edit Heading'}
        </h2>
        <div data-epi-edit="MainContentArea" className="grid grid-cols-3 xl:gap-x-11 sm:gap-x-8 gap-x-2">
          {MainContentArea && MainContentArea.length > 0 && MainContentArea.map((block, i) => {
            const { ContentLink } = block
            const { Id } = ContentLink
            return (
              <SelectaTopicCardBlock key={i} data={blockData[Id]} inEditMode={inEditMode} />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default React.memo(SelectaTopicBlock)
